export function OutlineTaskIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.0399 7.00195H13.9583C13.4281 7.00195 12.9983 7.43176 12.9983 7.96195V10.0404C12.9983 10.5706 13.4281 11.0004 13.9583 11.0004H20.0399C20.5701 11.0004 20.9999 10.5706 20.9999 10.0404V7.96195C20.9999 7.43176 20.5701 7.00195 20.0399 7.00195Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.0399 14.998H13.9583C13.4281 14.998 12.9983 15.4279 12.9983 15.958V18.0365C12.9983 18.5666 13.4281 18.9965 13.9583 18.9965H20.0399C20.5701 18.9965 20.9999 18.5666 20.9999 18.0365V15.958C20.9999 15.4279 20.5701 14.998 20.0399 14.998Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 5V8.99841H12.9984"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 8.99805V15.0797C6 16.1405 6.8592 16.9997 7.92 16.9997H12.9984"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 5H9.00001"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
